import React, { useState, useEffect } from 'react';

export default function LocationFilter({ value, onChange }) {
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    fetch('/api/credentials')
      .then(r => r.json())
      .then(setLocations)
      .catch(err => console.error('Error loading locations for filter:', err));
  }, []);

  return (
    <div className="filter-group location-filter">
      <label>📍 Location</label>
      <select value={value || ''} onChange={(e) => onChange(e.target.value)}>
        <option value="">All Locations</option>
        {locations.map(loc => (
          <option key={loc.id} value={loc.restaurant_id}>{loc.name}</option>
        ))}
      </select>
    </div>
  );
}
